import { Stack, useTheme } from "@mui/material";
import dayjs from "dayjs";
import { useClientQuery } from "web_myplann/Api/Client/useClientQuery";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DataRowCard } from "web_myplann/Shared/Components/DataRowCard";
import { EmptyListSkeleton } from "web_myplann/Shared/Components/EmptyListSkeleton";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";
import "dayjs/locale/cs";
import { IdCard } from "lucide-react";
import { useMemo } from "react";

export const PaperworkPage = () => {
	const theme = useTheme();
	const { t } = useResource();

	const { data: userData } = useClientQuery();

	const paperwork = useMemo(() => {
		dayjs.locale("cs");

		return (
			userData?.identificationDocuments.slice().sort((a, b) => {
				const typeCompare = (a.type ?? "").localeCompare(b.type ?? "");

				if (typeCompare !== 0) return typeCompare;

				if (a.validToDate && b.validToDate) {
					return (
						new Date(b.validToDate).valueOf() -
						new Date(a.validToDate).valueOf()
					);
				}

				if (a.validToDate) return -1;

				if (b.validToDate) return 1;

				return 0;
			}) || []
		);
	}, [userData]);

	return (
		<MyPlannLayout
			disableContentPadding
			topBar={
				<NavigationHeader
					title={t(Resources.Paperwork.title)}
					defaultRoute={Routing.Dashboard.path()}
				/>
			}
		>
			<Stack p={1.6}>
				{paperwork.length === 0 && (
					<EmptyListSkeleton
						label={t(Resources.Profile.EmptyList.Paperwork.label)}
						description={t(Resources.Profile.EmptyList.Paperwork.description)}
					/>
				)}
				{paperwork.map((doc, index) => (
					<DataRowCard
						key={doc.id}
						icon={
							<IdCard
								size={theme.iconSize.sm}
								color={theme.palette.deprecated.grey[700]}
							/>
						}
						label={t(
							Resources.Paperwork.Types[
								doc.type as keyof typeof Resources.Paperwork.Types
							],
						)}
						noDivider={paperwork.length - 1 === index}
						items={[
							// ToDo: Add in the future, once API returns it
							// {
							// 	label: t(Resources.Paperwork.DocumentNumber),
							// 	value: doc.documentNumber,
							// },
							{
								label: t(Resources.Paperwork.ExpirationDate),
								value: dateFormatter(doc.validToDate),
							},
						]}
					/>
				))}
			</Stack>
		</MyPlannLayout>
	);
};
